<template>

    <div class="table__wrapper table--invoices">
        <table>
            <thead>
                <tr>
                    <th>{{ trans('distrib.orders.tables.ref') }}</th>
                    <th v-if="is_distributor"> {{ trans('distrib.orders.tables.final_client') }} </th>
                    <th>{{ trans('distrib.orders.tables.numF') }} </th>
                    <th> {{ trans('distrib.orders.tables.crea_date') }} </th>
                    <th> {{ trans('distrib.orders.tables.due_date') }} </th>
                    <th> {{ trans('distrib.orders.tables.amount') }} </th>
                    <th> {{ trans('distrib.orders.tables.nItems') }} </th>
                    <th> {{ trans('distrib.orders.tables.status') }} </th>
                    <th> {{ trans('distrib.orders.tables.act') }} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(order, idx) in current_orders" :key="order.order_id " :class="order.status">
                    <td>
                        <p>{{(order.ref && order.ref !== '') ? order.ref : '-'}}</p>

                        <template v-if="!is_biome">
                            <span class="sub">
                                #ord-{{ order.order_id }}
                                <template v-if="order.bpo_id">
                                    <br>#bpo-{{ order.bpo_id }}
                                </template>
                            </span>
                        </template>
                        <template v-else>
                            <span class="sub">
                                <a
                                    :href="'https://anita.biomemakers.com/anita/orders/order/' + order.order_id "
                                >
                                    #ord-{{ order.order_id }}
                                </a>
                                <template v-if="order.bpo_id">
                                    <br>
                                    <a v-if="order.bpo_id"
                                       :href="'https://anita.biomemakers.com/anita/bpos/bpo/' + order.bpo_id "
                                    >
                                        #bpo-{{ order.bpo_id }}
                                    </a>
                                </template>
                            </span>
                        </template>


                    </td>

                    <!-- Pic of the final client -->
                    <td v-if="is_distributor" :title="order.final_client.name">
                        <img v-if="order.final_client" :src="order.final_client.pic">
                        {{ order.final_client.code }}
                    </td>

                    <td>
                        <p>{{ order.invoice ? order.invoice.number : trans('distrib.orders.status.no_inv') }}</p>

                    </td>
                    <td>
                        <p class="time--date" v-if="order.created_at != null">
                            {{ formatDate(order.created_at) }}
                            <span>{{ formatYear(order.created_at) }} </span>
                        </p>
                    </td>
                    <td>
                        <div v-if="order.invoice">
                            <p class="time--date" v-if="order.invoice.due_date != null">
                                {{ formatDate(order.invoice.due_date) }}
                                <span>{{ formatYear(order.invoice.due_date) }} </span>
                            </p>      
                            <p v-else>{{ trans('distrib.orders.status.no_venc') }}</p>  
                        </div>
                        <div v-else>
                            <p>{{ trans('distrib.orders.status.no_venc') }}</p>
                        </div>      
                    </td>
                    <td>
                        <div v-if="order.invoice">
                            <p>{{ formatCurrency(order.invoice.due_amount, order.invoice.currency) }}</p>
                        </div>
                        <div v-else>
                            <p>-</p>
                        </div>

                    </td>
                    <td>
                        <div v-if="order.invoice && order.invoice.items" class="flex-element flex-row flex-vcenter">
                            <p>{{order.invoice.total_items}}</p>
                                <div class="remaining__bulks">
                                    <div class="has__tooltip">
                                        <a class="see__more">
                                            <i class="icon-anita-arrow_down"></i>
                                        </a>
                                        <div class="td__tooltip">
                                            <p class="title">{{ trans('distrib.orders.tables.fullItems') }}</p>
                                            <ul>
                                            <li v-for="(line, ix) in order.invoice.items" :key="ix">
                                                <span>x{{line.num}}</span>
                                                <div class="flex-element flex-row flex-align-center">

                                                    <!--
                                                    <img :src="line.img" />
                                                    -->

                                                    <p>{{ [line.product, line.item].filter(x=>x).join(' - ') }}</p>
                                                </div>
                                            </li>
                                            <li>
                                                <span>x{{order.invoice.total_items}}</span>
                                                <p>{{ trans('distrib.orders.tables.total') }}</p>
                                            </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <div v-else>
                            <p>-</p>
                        </div>
                    </td>
                    <!-- Status -->
                    <td class="status">
                       <div v-if="order.invoice && !order.is_fake_invoice">
                           <p>{{ order.invoice.paid ? trans('distrib.orders.status.paid') : trans('distrib.orders.status.not_paid') }}</p>
                       </div>
                        <div v-else>
                            <p>-</p>
                        </div>
                    </td>

                    <!-- Agent -->
                    <td class="actions">
                        <a v-if="order.invoice && !order.is_fake_invoice" title="download"
                           :href="order.invoice.download_link"
                           target="_blank" data-ff-download=""
                           class="table__action" >
                                <ArrowDown/>
                        </a>
                    </td>
                    <td></td>

                </tr>

            </tbody>
        </table>

        <paginator v-if="pages.length>1" :numPages="pages.length" @goPage="goPage" />


    </div>

</template>

<style lang="scss" scoped >

</style>

<script>

    const PER_PAGE = 6;

    function doPages(array, chunk){

        const groups = [];

        for (let i=0, j=array.length; i<j; i+=chunk) {
            groups.push(array.slice(i,i+chunk));
        }

        return groups;

    }

    import {ArrowDown} from "lucide-vue-next";


    export default {

        components: {
            ArrowDown
    },
        props: [
            'orders',
            'is_biome',
            'is_distributor',
        ],

        data(){

            const pages = doPages(this.orders.items, PER_PAGE);

            return {
                pages,
                current_orders: pages[0],
                current_page: 0,
            };

        },
        methods: {
            formatDate (mydate) {
                return moment(mydate).format("DDMMM").replace(".","").toString()
            },

            formatYear (mydate) {
                return moment(mydate).format("YYYY")
            },
            goPage(page){
                this.current_orders = this.pages[page-1];
            },


          amISelected(i) {

          },

          bulksModifier(num) {
            let modClass = "modif--";
            (num < 3)? modClass += num : modClass += "multi";
            return modClass;
          },

          quickBulksMaker(bulks) {
            let qbulks = bulks;
            (bulks.length < 3)? "" : (bulks.length === 3)? "" : qbulks = qbulks.slice(0, 2);
            return qbulks;
          },


            formatCurrency(amount, currency){

                if(!amount) return '';

                if(currency === 'usd'){
                    return '$ ' + amount;
                } else if(currency === 'eur'){
                    return amount + ' €';
                }

                return amount + ' ' + currency;

            }

        }
    }

</script>